module.exports = __webpack_public_path__ + "static/Acta-Bold-38b0038897f88aabdf3fe03aa2d938a5.woff2";